module.exports = __webpack_public_path__ + "static/img/rh.83b294fc.jpg";